"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toFormData = function (element, namespace, data) {
    if (namespace === void 0) { namespace = ""; }
    if (data === void 0) { data = new FormData(); }
    Object.keys(element).forEach(function (key) {
        var value = element[key];
        var isObjectOrArray = typeof value === "object" && value !== null;
        var isFile = value instanceof File;
        var currentNamespace = namespace ? "".concat(namespace, "[").concat(key, "]") : key;
        if (isObjectOrArray && !isFile)
            toFormData(value, currentNamespace, data);
        else
            data.append(currentNamespace, value);
    });
    return data;
};
exports.default = toFormData;
